import { render, staticRenderFns } from "./showStudentExams.vue?vue&type=template&id=972e0cba&scoped=true&"
import script from "./showStudentExams.vue?vue&type=script&lang=js&"
export * from "./showStudentExams.vue?vue&type=script&lang=js&"
import style0 from "./showStudentExams.vue?vue&type=style&index=0&id=972e0cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e0cba",
  null
  
)

export default component.exports